// import { toast } from "react-hot-toast";

export const transformErrorResponse = (response) => {
    if(response?.data?.error?.length === 0){
        // toast.error(response?.data?.message);
        alert("error")
    }
    return response;
}